'use strict';

const minicart = require('./header/minicart');
const util = require('../utils/util');
const quickShopWishlist = require('./product/quickShopWishlist');
var initialized = false;

function addItemToCart(pid) {
    return Promise.resolve(
        $.ajax({
            type: 'POST',
            url: util.ajaxUrl(Urls.addProduct),
            data: 'Quantity=1&cartAction=update&pid=' + pid
        })
    );
}

/**
 * Redirect to cart page after adding product to cart providing the
 * cross-sell-pid for the analytics data to be added to the cart page
 * @param {string} pid - product id
 */
function onAddedToCart(pid) {
    window.location.href = `${Urls.cartShow}?cross-sell-pid=${pid}`;
}

function addToCart(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const pid = $target.attr('data-pid');
    const showQuickShop = $target.attr('data-show-quickshop');
    let options = {};

    if (!pid) return;

    if (showQuickShop === 'true') {
        const variationGroupId = $target.attr('data-productid');
        quickShopWishlist.init(variationGroupId, onAddedToCart);
        return;
    }

    addItemToCart(pid).then(function (response) {
        var splitted = response.split(util.contentSplitter);
        try {
            options = JSON.parse(splitted[1]);
        } catch (err) {}

        if ($target.parents('.cross-sell--v3').length > 0 || $target.parents('.pt_cart').length > 0) {
            onAddedToCart(pid);
        } else {
            if ($target.is('button') && $target.attr('data-added-text')) {
                $target.text($target.attr('data-added-text'));
                $target.attr('disabled', 'disabled');
                $target.trigger('blur');
            }
            // cartoverlay.show(splitted[2]);
        }
        minicart.update(splitted[0], options);
    });
}

/**
 * @function
 * @description Initialise the cross-sell module
 */
exports.init = function () {
    if ($('.cross-sell--v3 .cross-sell-slot').length > 0) {
        if ($('.cross-sell--v3 .cross-sell-slot .cross-sell-wrapper').length > 0) {
            $('.cross-sell-recommendations-cart').hide();
        } else {
            $('.cross-sell-recommendations-cart').show();
        }
    }

    if (initialized) return;
    initialized = true;

    // remove cross-sell-pid from URL to prevent false analytics on reload
    if (window.location.href.includes('cross-sell-pid=')) {
        window.history.replaceState({}, document.title, window.location.pathname);
    }

    const $body = $('body');
    $body.on('click', '.cross-sell-slot .add-to-cart', addToCart);
};
